import { Box, CardContent, Grid2, Typography } from '@mui/material';
import BasicLayout from 'pages/AuthenticationPages/_components/BasicLayout';
import { LoginFormSchema } from '../../../services/AuthService/schemas';
import zod from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useDoLogin } from '../../../services/AuthService/hooks/useMutations';
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import TextFieldComponent from '../../../components/TextFieldComponent';
import { LoadingButton } from '@mui/lab';
import React from 'react';
import logo_login from 'assets/images/logoProdutos/alertai_icon_blue_dark.svg';
import testeSvg from 'assets/images/svgs/SignInSVGS/4.svg';

type LoginFormInput = zod.infer<typeof LoginFormSchema>;

const TokenPasswordPage = () => {
  const { control, handleSubmit } = useForm<LoginFormInput>({
    resolver: zodResolver(LoginFormSchema),
    defaultValues: { email: '', password: '' },
  });

  const navigate = useNavigate();
  const { mutateAsync, isLoading } = useDoLogin();

  const handleLogin = (data: LoginFormInput) => {
    mutateAsync(data).then(() => {
      navigate('/lpr');
    });
  };

  return (
    <BasicLayout>
      <Card
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          position: 'absolute',
          backgroundColor: 'transparent',
        }}
      >
        <Grid2
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          sx={{ height: '100%' }}
        >
          <img src={testeSvg} alt="Desenho" width={500} />
        </Grid2>
        <CardContent
          sx={{
            backgroundColor: 'transparent',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box pt={4} pb={6} px={3} sx={{ width: '100%' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '15vh',
              }}
            >
              <img src={logo_login} width={260} />
            </Box>

            <Box
              onSubmit={() => handleSubmit(handleLogin)}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
                justifyContent: 'start',
                width: '100%',
                height: '50%',
                backgroundColor: 'transparent',
                borderRadius: '10px',
                padding: '30px',
              }}
            >
              <Typography color="white" variant="h5" marginY={'5px'}>
                Código de acesso
              </Typography>
              <Typography color="gray" marginY={'15px'}>
                Um código de 6 digitos foi enviada para o seu email.
              </Typography>
              <Box mb={1} sx={{ width: '100%' }}>
                <TextFieldComponent
                  label={'Código'}
                  type="number"
                  fullWidth
                ></TextFieldComponent>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'center',
                }}
              >
                <LoadingButton
                  type="submit"
                  color="primary"
                  variant="contained"
                  loadingPosition="center"
                  href="/app/authentication/newPassword"
                  sx={{
                    width: '70%',
                  }}
                >
                  Confirmar
                </LoadingButton>
                <LoadingButton
                  type="submit"
                  color="primary"
                  variant="outlined"
                  loadingPosition="center"
                  href="/app/authentication/recoverPassword"
                  sx={{
                    marginX: '10px',
                    width: '30%',
                  }}
                >
                  Voltar
                </LoadingButton>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </BasicLayout>
  );
};

export default TokenPasswordPage;
